/**
 * The lifecycle ticket of the sheet's fixed-children requests. A provider
 * kickoff takes a `ticket()`; a detach, recycle or rebind retires every ticket
 * issued so far (`retire()`), and the request's completion and its apply each
 * check `isCurrent(ticket)`. So a provider started before a detach cannot
 * install after a same-bind reconnect, while one started after the reconnect
 * applies exactly once.
 */
export class FixedChildrenLifetime {
  #epoch = 0;

  /** The ticket a provider kickoff takes now. */
  ticket(): number {
    return this.#epoch;
  }

  /** Whether `ticket` is still current: no detach, recycle or rebind since it was taken. */
  isCurrent(ticket: number): boolean {
    return ticket === this.#epoch;
  }

  /** Retire every ticket issued so far (the sheet's detach, recycle and rebind). */
  retire(): void {
    this.#epoch++;
  }
}
